"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var SingpassDxp_1 = require("../../../../../common/components/singpassDxp/SingpassDxp");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var TermsAndConditions_1 = require("../termsAndConditions/TermsAndConditions");
var SingpassEvents_1 = require("./enum/SingpassEvents");
var customEvent_1 = require("../../../../../common/service/customEvent");
var singpassContainerStyles_1 = require("./singpassContainerStyles");
var SingpassAccess_1 = require("./enum/SingpassAccess");
var SingpassContainer = function (_a) {
    var setVerificationData = _a.setVerificationData, setIsAccepted = _a.setIsAccepted, isAccepted = _a.isAccepted, verificationData = _a.verificationData;
    var _b, _c;
    var singpassRef = react_1.useRef(null);
    var _d = react_1.useState(false), setIsLoading = _d[1];
    var styles = singpassContainerStyles_1.default();
    react_1.useEffect(function () {
        var eventListener = function (event) {
            var detail = event.detail;
            setVerificationData(detail);
        };
        customEvent_1.customEvent.listen(SingpassEvents_1.SingpassEvents.SINGPASS_AUTHORIZATION, eventListener);
        return function () {
            customEvent_1.customEvent.removeListener(SingpassEvents_1.SingpassEvents.SINGPASS_AUTHORIZATION, eventListener);
        };
    }, [setVerificationData]);
    return (<core_1.Box className={styles.root} data-test="checkout:identityVerification:container">
      <core_1.Grid container className={styles.titleContainer}>
        <core_1.Grid item xs={12}>
          {((_b = verificationData) === null || _b === void 0 ? void 0 : _b.progress) !== SingpassAccess_1.SingpassAccess.Granted && (<core_1.Typography variant={'body1'} className={styles.description} data-test="checkout:singpass:label">
              <Translation_1.default id={'trans__checkout__next_step__customer_information__singpass_login_label'}/>
            </core_1.Typography>)}
        </core_1.Grid>
      </core_1.Grid>
      <core_1.Box className={styles.disclaimerContainer} data-test="checkout:disclaimer:container">
        <TermsAndConditions_1.default isAccepted={isAccepted} setIsAccepted={setIsAccepted}/>
      </core_1.Box>
      {((_c = verificationData) === null || _c === void 0 ? void 0 : _c.progress) !== SingpassAccess_1.SingpassAccess.Granted && (<core_1.Box className={styles.singpassContainer} data-test="checkout:singpass:container">
          <SingpassDxp_1.default ref={singpassRef} setLoadingStatus={setIsLoading}/>
        </core_1.Box>)}
    </core_1.Box>);
};
exports.default = SingpassContainer;
